import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from 'components/TextField';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import {
  DtgWrapper,
  ColorWrapper,
} from 'styles/pages/order-details/itemsSummary';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const openCloudinaryWidget = (folder, clientAllowedFormats, cb) => {
  const myWidget = window.cloudinary.createUploadWidget(
    {
      cloudName: 'big-oven-tees-inc',
      uploadPreset: 'tnedst8q',
      folder,
      clientAllowedFormats,
    },
    (error, result) => {
      if (!error && result && result.event === 'success') {
        cb(result?.info?.secure_url);
        myWidget.close();
      }
    }
  );
  myWidget.open();
};

const AOP = ({ setOrderLine, selectedOrderLine, aopVectorFile }) => {
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);

  return (
    <DtgWrapper>
      <ColorWrapper>
        {aopVectorFile ? (
          <InsertDriveFileIcon style={{ color: '#000' }} />
        ) : (
          <ErrorOutlineIcon style={{ color: 'orange' }} />
        )}

        <TextField
          fullWidth={true}
          label='Vector File (.eps) or PDF File (.pdf)'
          disabled={true}
          size='small'
          value={aopVectorFile || ''}
          onChange={(aopVectorFile) =>
            setOrderLine({
              ...selectedOrderLine,
              aopVectorFile,
            })
          }
        />
        <CloudUploadIcon
          onClick={() => {
            openCloudinaryWidget(
              `BOTApp/${emailid}/AOPMockFiles`,
              ['eps', 'pdf'],
              (secureUrl) => {
                setOrderLine({
                  ...selectedOrderLine,
                  aopVectorFile: secureUrl,
                });
              }
            );
          }}
        />
      </ColorWrapper>
    </DtgWrapper>
  );
};

export default AOP;
